import { render, staticRenderFns } from "./Giveaway.vue?vue&type=template&id=05af7ddf&scoped=true&"
import script from "./Giveaway.vue?vue&type=script&lang=js&"
export * from "./Giveaway.vue?vue&type=script&lang=js&"
import style0 from "./Giveaway.vue?vue&type=style&index=0&id=05af7ddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af7ddf",
  null
  
)

export default component.exports